import { Flex, Label, Span, styled } from '@fareye/ui'
import { FaCheckCircle } from '@fareye/utils'
import React from 'react'
import { MMStopsDetails } from './../../style/styled'
import { FieldValue } from './FieldValue'
import { displayTimeSecondFormat } from './function'
import { useTranslation } from '@fareye/common'

export const HR = styled.hr`
  height: 1px;
  border: 0.5px solid #dadada;
  box-sizing: border-box;
`

function MileStoneDetails({ stopData, currentData, positionStyle }: any) {
  const {
    milestoneName,
    milestoneRawStatus,
    packageStatus,
    milestoneEventTime
  } = stopData
  const {
    milestoneEventLocationName,
    milestoneCarrierStatus,
    carrierName
  } = currentData
  const { t } = useTranslation()
  return (
    <MMStopsDetails className="popover" style={{ ...positionStyle }}>
      <Flex
        alignItemsCenter
        justifyContentFlexStart
        style={{ marginBottom: '8px' }}
      >
        <FaCheckCircle color="#409e33" style={{ background: '#fff' }} />
        <Label fontSize={12}>{milestoneName}</Label>
      </Flex>
      <FieldValue
        valueStyle={{
          maxWidth: 90,
          justifyContent: 'center',
          backgroundColor: '#FBEFC3',
          marginBottom: '10px'
        }}
        value={milestoneRawStatus}
      />
      <HR />
      <FieldValue
        style={{
          marginBottom: 4,
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
        labelStyle={{ color: '#212121', fontWeight: 500 }}
        label={`${t('Date')} & ${t('Time')}`}
        value={
          milestoneEventTime ? displayTimeSecondFormat(milestoneEventTime) : '-'
        }
      />
      <FieldValue
        style={{
          marginBottom: 4,
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
        valueStyle={{ color: '#212121', fontWeight: 500 }}
        label={t('Location')}
        value={milestoneEventLocationName}
      />
      <FieldValue
        style={{
          marginBottom: 4,
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
        valueStyle={{ color: '#212121', fontWeight: 500 }}
        label={`${t('Carrier')}`}
        value={carrierName}
      />
      <FieldValue
        style={{
          marginBottom: 4,
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
        valueStyle={{ color: '#212121', fontWeight: 500 }}
        label={`${t('Carrier Status')}`}
        value={t(milestoneCarrierStatus)}
      />
    </MMStopsDetails>
  )
}

export default MileStoneDetails
